import React from 'react';
import ReactDOM from 'react-dom';
const mainDrawerPortal = document.getElementById('main-drawer-portal');

export const MainDrawerPortal = ({ children }: any) => {
  return mainDrawerPortal
    ? ReactDOM.createPortal(
        children,
        mainDrawerPortal
    ) : <></>
}
